import React from "react";
import { Box, Stack, Typography } from "@mui/material";

import GaugeChart from "../GaugeChart/GaugeChart";
import Maps from "../Maps/Maps";

// export type ChipProps = MuChipProps & {}

const GUAGE_SERIES_OPTIONS = {
  type: "gauge",
  startAngle: 0,
  endAngle: -360,
  radius: "100%",
  splitLine: {
    show: false,
  },
  axisTick: {
    show: false,
  },
  axisLabel: {
    show: false,
  },
  anchor: {
    show: false,
  },
  pointer: {
    show: false,
  },
  axisLine: {
    lineStyle: {
      color: [[1, "#ffffff12"]],
      width: 5,
    },
  },
  progress: {
    show: true,
    overlap: false,
    roundCap: true,
    itemStyle: {
      color: "var(--mui-palette-secondary-100)",
    },
  },
  detail: {
    valueAnimation: true,
    offsetCenter: [0, "0%"],
    fontSize: 14,
    fontWeight: "500",
    color: "var(--mui-palette-primary-contrastText)",
    formatter: "{value}%",
  },
};

export interface MapCardProps {
  value?: { id: string; name: string; code: string };
  onSelectMap: (countryId: string, countryName: string, code: string) => void;
  clientsAmount?: string | number;
  clientsLoyality?: string;
  label?: string;
}

const MapCard = ({ value, onSelectMap, clientsAmount, clientsLoyality, label }: MapCardProps) => {
  return (
    <Stack
      sx={{
        borderRadius: "12px",
        border: "1px solid",
        borderColor: "divider",
        bgcolor: "background.paper",
        boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.04), 0px 2px 6px rgba(16, 24, 40, 0.06)",
        padding: "16px",
        maxWidth: "100%",
        height: "100%",
      }}>
      <Maps country={value?.id} onSelect={onSelectMap} />
      <Box
        sx={{
          borderRadius: "12px",
          background: "var(--mui-palette-primary-main)",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "16px",
        }}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          <Box>
            <Typography
              sx={{
                fontSize: "14px",
                fontWeight: 500,
                color: "var(--mui-palette-primary-contrastText)",
              }}>
              {value?.name}
            </Typography>
            <Typography sx={{ fontSize: "10px", fontWeight: 400, color: "#ffffffb8" }}>
              {label}
            </Typography>
          </Box>
          <Box sx={{ display: "flex", gap: "4px", alignItems: "center" }}>
            <Typography
              component={"span"}
              sx={{
                fontSize: "12px",
                fontWeight: 500,
                color: "var(--mui-palette-primary-contrastText)",
              }}>
              {clientsAmount}
            </Typography>
          </Box>
        </Box>
        <Box>
          <GaugeChart
            style={{ width: "57px", height: "57px" }}
            options={{
              series: {
                ...GUAGE_SERIES_OPTIONS,
                data: [
                  {
                    value: clientsLoyality,
                  },
                ],
              },
            }}
          />
        </Box>
      </Box>
    </Stack>
  );
};

export default MapCard;
